/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('../plugins');

window.Vue = require('vue');

import VueToast from 'vue-toast-notification';
import Select2 from 'v-select2-component';
import authLocation from './../reusable-components/auth_location.vue';
import testComponent from "./components/TestComponent.vue";




// const demo_page= () => import('./components/demoPage.vue');
Vue.use(VueToast);
import 'vue-toast-notification/dist/theme-default.css';
import BaseButton from './components/UI/BaseButton.vue';
const landing_page= () => import('./Views/index.vue').then(m => m.default || m);
// const demo_page= () => import('./components/demoPage.vue');
const demo_page= () => import('./Views/demoPage.vue').then(m => m.default || m);
const book_repair= () => import('./Views/bookRepair.vue').then(m => m.default || m);
const coming_soon = () => import('./Views/commingSoon.vue').then(m => m.default || m);
const how_it_works = () => import('./Views/howItWork.vue').then(m => m.default || m);
const about_us= () => import('./Views/aboutUs.vue').then(m => m.default || m);
const pricing= () => import('./Views/pricing.vue').then(m => m.default || m);
const services= () => import('./Views/servicesPage.vue').then(m => m.default || m);
const terms_and_conditions = () => import('./Views/termAndConditions.vue').then(m => m.default || m);
const privacy_policy = () => import('./Views/privacyPolicy.vue').then(m => m.default || m);
const all_technicians = () => import('./Views/AllTechnicians.vue').then(m => m.default || m);
const features_marketing = () => import('./Views/features/marketing.vue').then(m => m.default || m);
const online_appointments = () => import('./Views/features/onlineAppointments.vue').then(m => m.default || m);
const store_credits = () => import('./Views/features/storeCredits.vue').then(m => m.default || m);
const point_of_sale = () => import('./Views/features/pointOfSale.vue').then(m => m.default || m);
import public_form from '../views/appointments/public_form';
const payments = () => import('./Views/features/payments.vue').then(m => m.default || m);
const self_check_in = () => import('./Views/features/selfCheckIn.vue').then(m => m.default || m);
const customer_facing = () => import('./Views/features/customerFacing.vue').then(m => m.default || m);
// const accordian = () => import('./components/reusablecomponent/accordian.vue').then(m => m.default || m);
const repair_ticket = () => import('./Views/features/repairTicket.vue').then(m => m.default || m);
const employee_mangement = () => import('./Views/features/employeeManagement.vue').then(m => m.default || m);
const inventory = () => import('./Views/features/inventory.vue').then(m => m.default || m);
const billing_invoice = () => import('./Views/features/billingInvoice.vue').then(m => m.default || m);
const reporting = () => import('./Views/features/reporting.vue').then(m => m.default || m);
import the_header from './layouts/TheHeader.vue';
import the_footer from './layouts/TheFooter.vue';
import technician_public_slots from '../frontend/components/publicSlots';




/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    components:{
        auth_location: authLocation,
        test_component:testComponent,
        Select2,
        landing_page:landing_page,
        BaseButton,
        demo_page:demo_page,
        book_repair:book_repair,
        coming_soon: coming_soon,
        about_us:about_us,
        pricing:pricing,
        how_it_works: how_it_works,
        services: services,
        terms_and_conditions: terms_and_conditions,
        privacy_policy: privacy_policy,
        all_technicians: all_technicians,
        features_marketing:features_marketing,
        online_appointments:online_appointments,
        store_credits:store_credits,
        point_of_sale:point_of_sale,
        public_form:public_form,
        payments:payments,
        self_check_in:self_check_in,
        customer_facing:customer_facing,
        // accordian:accordian,
        repair_ticket:repair_ticket,
        employee_mangement:employee_mangement,
        inventory:inventory,
        billing_invoice:billing_invoice,
        reporting:reporting,
        the_header:the_header,
        the_footer:the_footer,
        technician_public_slots:technician_public_slots,
    }
});

